<template>
  <table border="1" cellpadding="6" cellspacing="0" style="border-collapse: collapse;">
    <tbody
      v-for="(item, index) in lists"
      :key="index"
      class="dib"
    >
      <tr class="tac">
        <td>
          <el-date-picker
            v-model="item.date"
            type="date"
            placeholder="选择日期"
            style="width: 140px;"
            size="small"
            @change="handlerDateRepeat(index)"
          />
        </td>
      </tr>
      <tr class="tac">
        <td>
          <input
            v-model.number="item.quota"
            type="number"
            style="width: 100px; height: 20px; text-align: center;"
          />
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="mini"
            @click="delItem(index)"
          />
        </td>
      </tr>
    </tbody>

    <tr class="budget_add">
      <!-- tr 内部必须加 td -->
        <div>
          <div class="mt-8 mb-6">
            <el-button type="primary" size="mini" @click="addItem"> 添加</el-button>
          </div>
          <div class="mb-8">
            <!-- 上传组件 -->
            <el-upload
              :show-file-list="false"
              accept=".xlsx,.xls"
              :before-upload="importExcel"
              action="none"
            >
            <el-button type="success" size="mini">导入</el-button>
            </el-upload>
          </div>
        </div>
    </tr>
  </table>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  name: 'BudgetTable',
  props: {
    lists: {
      type: Array,
      default: () => []
    }
  },
  // 🔥 监听 lists 变化，只要有重复日期就报错
  watch: {
    lists: {
      handler (val) {
        let dateMap = {}
        for (let item of val) {
          if (dateMap[item.date]) {
            this.$message.error(`数据错误：日期【${item.date}】重复！`)
            return
          }
          dateMap[item.date] = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 统一日期格式化 → 全部变成 YYYY-MM-DD
    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    // 专门格式化 Excel 日期
    formatExcelDate (val) {
      if (!val) return ''
      if (typeof val === 'number') {
        const d = XLSX.SSF.parse_date_code(val)
        return `${d.y}-${String(d.m).padStart(2, 0)}-${String(d.d).padStart(2, 0)}`
      }
      return this.formatDate(val)
    },
    handlerDateRepeat (index) {
      this.lists[index].date = this.formatDate(this.lists[index].date)

      let dateMap = {}
      for (let item of this.lists) {
        if (dateMap[item.date]) {
          this.$message.error(`数据错误：日期【${item.date}】重复！`)
          return
        }
        dateMap[item.date] = true
      }
    },
    // 获取今天日期
    getToday () {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    // 新增
    // 新增 校验重复日期
    addItem () {
      const today = this.getToday()
      // const hasSame = this.lists.some(item => item.date === today)

      // if (hasSame) {
      // this.$message.error('今日日期已存在，不可重复添加！')
      // return
      // }

      this.lists.push({
        date: today,
        quota: 0
      })
      this.$emit('update:lists', this.lists)
    },
    // 删除
    delItem (index) {
      this.lists.splice(index, 1)
      this.$emit('update:lists', this.lists)
    },

    // ======================
    // 导入 Excel（日期、额度）
    // ======================
    importExcel (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const sheet = workbook.Sheets[workbook.SheetNames[0]]
          const json = XLSX.utils.sheet_to_json(sheet)

          const arr = json.map(item => {
            const keys = Object.keys(item)
            return {
              date: this.formatExcelDate(item[keys[0]]),
              quota: Number(item[keys[1]] || 0)
            }
          })

          // 1. Excel内部重复
          const dateSet = new Set()
          for (let item of arr) {
            if (dateSet.has(item.date)) {
              this.$message.error(`导入失败：Excel 内日期【${item.date}】重复`)
              return
            }
            dateSet.add(item.date)
          }

          this.lists = arr
          this.$emit('update:lists', arr)
          this.$message.success('导入成功')
          this.$message.success('导入成功')
        } catch (err) {
          this.$message.error('导入失败')
        }
      }
      reader.readAsArrayBuffer(file)
      return false
    }
  }
}
</script>

<style scoped>
.dib {
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}
.tac {
  text-align: center;
}
.budget_add {
  width: 80px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/budget-table.vue